import { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import {
  patchNotificationCustomerTicketOpen,
  CUSTOMER_PORTAL_TICKET_NOTIFICATION_EVENT,
} from '../../../utils/notificationNavigation';

const RESERVED_SEGMENTS = new Set([
  'my-tickets',
  'create',
  'new',
  'attachments',
  'feedback',
]);

/**
 * Deep-link /portal/tickets/:id into My Tickets detail panel (same as notification opens).
 * Numeric :id is the ticket database ID.
 */
export default function PortalTicketDetailOpenRedirect() {
  const { id } = useParams();

  useEffect(() => {
    const segment = String(id || '').trim();
    if (!segment || RESERVED_SEGMENTS.has(segment) || !/^\d+$/.test(segment)) {
      return;
    }
    patchNotificationCustomerTicketOpen({ ticketId: segment });
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent(CUSTOMER_PORTAL_TICKET_NOTIFICATION_EVENT));
    }
  }, [id]);

  return <Navigate to="/portal/tickets" replace />;
}
